module.exports = __webpack_public_path__ + "img/authForteCodeAchat.5def728c.png";